var _marker, _marker2, _marker3, _marker4, _marker5, _rect, _rect2, _text, _text2, _line, _rect3, _text3, _rect4, _text4, _text5, _line2, _text6, _text7, _rect5, _text8, _text9, _text0, _line3, _text1, _rect6, _line4, _text10, _text11, _text12, _text13, _line5, _line6, _line7, _rect7, _text14, _line8, _circle, _text15, _circle2, _text16, _circle3, _text17, _circle4, _text18, _text19, _rect8, _text20, _line9, _circle5, _text21, _circle6, _text22, _circle7, _text23, _circle8, _text24, _text25, _rect9, _text26, _line0, _circle9, _text27, _circle0, _text28, _circle1, _text29, _circle10, _text30, _text31, _path, _line1, _path2, _rect0, _text32, _line10, _rect1, _text33, _text34, _rect10, _text35, _text36, _text37, _rect11, _text38, _text39, _line11, _circle11, _text40, _circle12, _text41, _line12, _rect12, _text42, _text43, _line13, _text44, _line14, _text45, _line15, _text46, _line16, _text47, _line17, _text48, _line18, _text49, _line19, _text50, _line20, _text51;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEtlOpenaiPipeline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 960,
    height: 660,
    viewBox: "0 0 960 660",
    xmlns: "http://www.w3.org/2000/svg",
    fontFamily: "Inter, system-ui, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _marker || (_marker = /*#__PURE__*/React.createElement("marker", {
    id: "mc",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#06B6D4"
  }))), _marker2 || (_marker2 = /*#__PURE__*/React.createElement("marker", {
    id: "mg",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#22c55e"
  }))), _marker3 || (_marker3 = /*#__PURE__*/React.createElement("marker", {
    id: "mv",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#a78bfa"
  }))), _marker4 || (_marker4 = /*#__PURE__*/React.createElement("marker", {
    id: "mt",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#10b981"
  }))), _marker5 || (_marker5 = /*#__PURE__*/React.createElement("marker", {
    id: "mb",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#7dd3fc"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0c1628"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#060c14"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 660,
    fill: "url(#bg2)",
    rx: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 660,
    fill: "none",
    rx: 12,
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 36,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: -0.3
  }, "Azure Secure ETL Normalization Platform")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 480,
    y: 54,
    textAnchor: "middle",
    fill: "#7dd3fc",
    fontSize: 10
  }, "ADLS Gen2 \xB7 Azure Data Factory \xB7 Azure Maps \xB7 Azure OpenAI \xB7 Azure SQL Database \xB7 Private Endpoints \xB7 VNet")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 68,
    x2: 920,
    y2: 68,
    stroke: "rgba(255,255,255,0.07)",
    strokeWidth: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 192,
    y: 82,
    width: 740,
    height: 530,
    rx: 8,
    fill: "rgba(245,158,11,0.02)",
    stroke: "#F59E0B",
    strokeWidth: 1,
    strokeDasharray: "6,4"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 921,
    y: 98,
    textAnchor: "end",
    fill: "#92400e",
    fontSize: 8,
    fontStyle: "italic"
  }, "Azure VNet")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 90,
    width: 128,
    height: 56,
    rx: 6,
    fill: "#0a1628",
    stroke: "#06B6D4",
    strokeWidth: 1.5
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 112,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 11,
    fontWeight: 700
  }, "External Client")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 128,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9
  }, "partner CSV files")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 118,
    x2: 200,
    y2: 118,
    stroke: "#06B6D4",
    strokeWidth: 1.5,
    markerEnd: "url(#mc)"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 175,
    y: 111,
    textAnchor: "middle",
    fill: "#0e7490",
    fontSize: 8.5
  }, "SFTP")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 175,
    y: 130,
    textAnchor: "middle",
    fill: "#334155",
    fontSize: 7.5
  }, "SSH key auth")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 90,
    width: 168,
    height: 56,
    rx: 6,
    fill: "#0a1628",
    stroke: "#7dd3fc",
    strokeWidth: 1.5
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 286,
    y: 110,
    textAnchor: "middle",
    fill: "#7dd3fc",
    fontSize: 12,
    fontWeight: 700
  }, "ADLS Gen2")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 286,
    y: 125,
    textAnchor: "middle",
    fill: "#94a3b8",
    fontSize: 9
  }, "Landing Zone \xB7 CSV files")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 286,
    y: 139,
    textAnchor: "middle",
    fill: "#334155",
    fontSize: 7.5
  }, "native SFTP \xB7 no dedicated servers")), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 286,
    y1: 146,
    x2: 286,
    y2: 172,
    stroke: "#a78bfa",
    strokeWidth: 1.5,
    strokeDasharray: "3,2",
    markerEnd: "url(#mv)"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 162,
    fill: "#6b4fa0",
    fontSize: 7.5
  }, "event trigger")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 174,
    width: 720,
    height: 56,
    rx: 6,
    fill: "rgba(139,92,246,0.07)",
    stroke: "#8b5cf6",
    strokeWidth: 1.5,
    strokeDasharray: "5,3"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 760,
    y1: 178,
    x2: 760,
    y2: 226,
    stroke: "rgba(139,92,246,0.2)",
    strokeWidth: 1
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 481,
    y: 196,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 13,
    fontWeight: 700
  }, "Azure Data Factory")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 481,
    y: 212,
    textAnchor: "middle",
    fill: "#7c6fad",
    fontSize: 9
  }, "Orchestration \xB7 metadata validation \xB7 integrity checks \xB7 file archival")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 841,
    y: 196,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 10,
    fontWeight: 600
  }, "Managed IR")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 841,
    y: 212,
    textAnchor: "middle",
    fill: "#7c6fad",
    fontSize: 8
  }, "private connectivity")), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 302,
    y1: 230,
    x2: 302,
    y2: 250,
    stroke: "#22c55e",
    strokeWidth: 1.5,
    markerEnd: "url(#mg)"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 555,
    y1: 230,
    x2: 555,
    y2: 250,
    stroke: "#10b981",
    strokeWidth: 1.5,
    markerEnd: "url(#mt)"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 822,
    y1: 230,
    x2: 822,
    y2: 250,
    stroke: "#a78bfa",
    strokeWidth: 1.5,
    markerEnd: "url(#mv)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    y: 252,
    width: 200,
    height: 118,
    rx: 6,
    fill: "#0a1628",
    stroke: "#22c55e",
    strokeWidth: 1.5
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 302,
    y: 272,
    textAnchor: "middle",
    fill: "#22c55e",
    fontSize: 11,
    fontWeight: 700
  }, "Data Cleaning")), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 215,
    y1: 279,
    x2: 389,
    y2: 279,
    stroke: "rgba(34,197,94,0.12)",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 292,
    r: 2.5,
    fill: "#22c55e",
    opacity: 0.7
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 229,
    y: 296,
    fill: "#cbd5e1",
    fontSize: 9
  }, "Dates \xB7 nulls \xB7 text encoding")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 308,
    r: 2.5,
    fill: "#22c55e",
    opacity: 0.7
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 229,
    y: 312,
    fill: "#cbd5e1",
    fontSize: 9
  }, "Dedup \xB7 invalid records")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 324,
    r: 2.5,
    fill: "#06B6D4",
    opacity: 0.85
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 229,
    y: 328,
    fill: "#7dd3fc",
    fontSize: 9
  }, "Phone to E.164 format")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 340,
    r: 2.5,
    fill: "#06B6D4",
    opacity: 0.85
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 229,
    y: 344,
    fill: "#7dd3fc",
    fontSize: 9
  }, "Country code extraction")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 302,
    y: 362,
    textAnchor: "middle",
    fill: "#334155",
    fontSize: 7.5
  }, "deterministic rules")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 462,
    y: 252,
    width: 186,
    height: 118,
    rx: 6,
    fill: "#0a1628",
    stroke: "#10b981",
    strokeWidth: 1.5
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 555,
    y: 272,
    textAnchor: "middle",
    fill: "#34d399",
    fontSize: 11,
    fontWeight: 700
  }, "Azure Maps")), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 475,
    y1: 279,
    x2: 635,
    y2: 279,
    stroke: "rgba(16,185,129,0.12)",
    strokeWidth: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 479,
    cy: 292,
    r: 2.5,
    fill: "#10b981",
    opacity: 0.7
  })), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 488,
    y: 296,
    fill: "#cbd5e1",
    fontSize: 9
  }, "Address parsing &amp; validation")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 479,
    cy: 308,
    r: 2.5,
    fill: "#10b981",
    opacity: 0.7
  })), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 488,
    y: 312,
    fill: "#cbd5e1",
    fontSize: 9
  }, "Street \xB7 city \xB7 postal code")), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 479,
    cy: 324,
    r: 2.5,
    fill: "#10b981",
    opacity: 0.7
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 488,
    y: 328,
    fill: "#cbd5e1",
    fontSize: 9
  }, "Country identification")), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 479,
    cy: 340,
    r: 2.5,
    fill: "#10b981",
    opacity: 0.7
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 488,
    y: 344,
    fill: "#cbd5e1",
    fontSize: 9
  }, "Geographic coordinates")), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 555,
    y: 362,
    textAnchor: "middle",
    fill: "#334155",
    fontSize: 7.5
  }, "Geocoding API")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 722,
    y: 252,
    width: 200,
    height: 118,
    rx: 6,
    fill: "#0a1628",
    stroke: "#a78bfa",
    strokeWidth: 1.5
  })), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 822,
    y: 272,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 11,
    fontWeight: 700
  }, "Azure OpenAI")), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 735,
    y1: 279,
    x2: 909,
    y2: 279,
    stroke: "rgba(167,139,250,0.12)",
    strokeWidth: 1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 739,
    cy: 292,
    r: 2.5,
    fill: "#a78bfa",
    opacity: 0.7
  })), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 748,
    y: 296,
    fill: "#cbd5e1",
    fontSize: 9
  }, "Org name normalization")), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 739,
    cy: 308,
    r: 2.5,
    fill: "#a78bfa",
    opacity: 0.7
  })), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 748,
    y: 312,
    fill: "#cbd5e1",
    fontSize: 9
  }, "Abbreviation expansion")), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 739,
    cy: 324,
    r: 2.5,
    fill: "#a78bfa",
    opacity: 0.7
  })), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 748,
    y: 328,
    fill: "#cbd5e1",
    fontSize: 9
  }, "Capitalization correction")), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 739,
    cy: 340,
    r: 2.5,
    fill: "#a78bfa",
    opacity: 0.7
  })), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 748,
    y: 344,
    fill: "#cbd5e1",
    fontSize: 9
  }, "Free-text standardization")), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 822,
    y: 362,
    textAnchor: "middle",
    fill: "#334155",
    fontSize: 7.5
  }, "semantic LLM normalization")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 302 370 L 302 396 L 440 396 L 440 410",
    fill: "none",
    stroke: "#22c55e",
    strokeWidth: 1.5,
    markerEnd: "url(#mg)"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 555,
    y1: 370,
    x2: 555,
    y2: 410,
    stroke: "#10b981",
    strokeWidth: 1.5,
    markerEnd: "url(#mt)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 822 370 L 822 396 L 660 396 L 660 410",
    fill: "none",
    stroke: "#a78bfa",
    strokeWidth: 1.5,
    markerEnd: "url(#mv)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 398,
    y: 410,
    width: 306,
    height: 90,
    rx: 6,
    fill: "#0a1628",
    stroke: "#3b82f6",
    strokeWidth: 1.5
  })), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 551,
    y: 432,
    textAnchor: "middle",
    fill: "#93c5fd",
    fontSize: 12,
    fontWeight: 700
  }, "Azure SQL Database")), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 411,
    y1: 439,
    x2: 691,
    y2: 439,
    stroke: "rgba(59,130,246,0.12)",
    strokeWidth: 1
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 414,
    y: 444,
    width: 116,
    height: 30,
    rx: 3,
    fill: "rgba(59,130,246,0.08)",
    stroke: "rgba(59,130,246,0.28)",
    strokeWidth: 1
  })), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 472,
    y: 459,
    textAnchor: "middle",
    fill: "#60a5fa",
    fontSize: 9,
    fontWeight: 600
  }, "RAW Layer")), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 472,
    y: 469,
    textAnchor: "middle",
    fill: "#334155",
    fontSize: 7
  }, "audit \xB7 reprocessing")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 538,
    y: 444,
    width: 150,
    height: 30,
    rx: 3,
    fill: "rgba(34,197,94,0.08)",
    stroke: "rgba(34,197,94,0.28)",
    strokeWidth: 1
  })), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    x: 613,
    y: 459,
    textAnchor: "middle",
    fill: "#4ade80",
    fontSize: 9,
    fontWeight: 600
  }, "Curated Layer")), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    x: 613,
    y: 469,
    textAnchor: "middle",
    fill: "#334155",
    fontSize: 7
  }, "clean \xB7 normalized \xB7 enriched")), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    x: 551,
    y: 491,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 8
  }, "Private Endpoint \xB7 no public SQL access")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 718,
    y: 412,
    width: 196,
    height: 88,
    rx: 6,
    fill: "rgba(249,115,22,0.03)",
    stroke: "#f97316",
    strokeWidth: 1,
    strokeDasharray: "4,2"
  })), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    x: 816,
    y: 432,
    textAnchor: "middle",
    fill: "#fb923c",
    fontSize: 10,
    fontWeight: 700
  }, "VM + NSG")), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    x: 816,
    y: 446,
    textAnchor: "middle",
    fill: "#78350f",
    fontSize: 7.5
  }, "Phase 2 \u2014 administrative access")), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 730,
    y1: 453,
    x2: 902,
    y2: 453,
    stroke: "rgba(249,115,22,0.1)",
    strokeWidth: 1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 733,
    cy: 466,
    r: 2,
    fill: "#f97316",
    opacity: 0.6
  })), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    x: 742,
    y: 470,
    fill: "#a05a30",
    fontSize: 8.5
  }, "Admin ADLS access (mounted drive)")), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 733,
    cy: 483,
    r: 2,
    fill: "#f97316",
    opacity: 0.6
  })), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    x: 742,
    y: 487,
    fill: "#a05a30",
    fontSize: 8.5
  }, "NSG: IP / VPN restriction")), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 551,
    y1: 500,
    x2: 551,
    y2: 526,
    stroke: "#7dd3fc",
    strokeWidth: 1.5,
    markerEnd: "url(#mb)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 528,
    width: 370,
    height: 52,
    rx: 6,
    fill: "rgba(125,211,252,0.04)",
    stroke: "#7dd3fc",
    strokeWidth: 1.5
  })), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    x: 551,
    y: 549,
    textAnchor: "middle",
    fill: "#7dd3fc",
    fontSize: 12,
    fontWeight: 700
  }, "ADLS Gen2 \u2014 Output")), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    x: 551,
    y: 565,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9
  }, "Standardized datasets \xB7 downstream analytics &amp; reporting")), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 622,
    x2: 42,
    y2: 622,
    stroke: "#06B6D4",
    strokeWidth: 2
  })), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 626,
    fill: "#475569",
    fontSize: 9
  }, "SFTP ingestion")), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 138,
    y1: 622,
    x2: 158,
    y2: 622,
    stroke: "#a78bfa",
    strokeWidth: 1.5,
    strokeDasharray: "3,2"
  })), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    x: 164,
    y: 626,
    fill: "#475569",
    fontSize: 9
  }, "ADF trigger")), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 236,
    y1: 622,
    x2: 256,
    y2: 622,
    stroke: "#22c55e",
    strokeWidth: 1.5
  })), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    x: 262,
    y: 626,
    fill: "#475569",
    fontSize: 9
  }, "Data Cleaning")), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 352,
    y1: 622,
    x2: 372,
    y2: 622,
    stroke: "#10b981",
    strokeWidth: 1.5
  })), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    x: 378,
    y: 626,
    fill: "#475569",
    fontSize: 9
  }, "Azure Maps")), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 456,
    y1: 622,
    x2: 476,
    y2: 622,
    stroke: "#a78bfa",
    strokeWidth: 1.5
  })), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    x: 482,
    y: 626,
    fill: "#475569",
    fontSize: 9
  }, "Azure OpenAI")), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 566,
    y1: 622,
    x2: 586,
    y2: 622,
    stroke: "#7dd3fc",
    strokeWidth: 1.5
  })), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    x: 592,
    y: 626,
    fill: "#475569",
    fontSize: 9
  }, "Output flow")), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 622,
    x2: 680,
    y2: 622,
    stroke: "#F59E0B",
    strokeWidth: 1,
    strokeDasharray: "5,3"
  })), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    x: 686,
    y: 626,
    fill: "#475569",
    fontSize: 9
  }, "VNet boundary")), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 772,
    y1: 622,
    x2: 792,
    y2: 622,
    stroke: "#f97316",
    strokeWidth: 1,
    strokeDasharray: "3,2"
  })), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    x: 798,
    y: 626,
    fill: "#475569",
    fontSize: 9
  }, "Phase 2")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtlOpenaiPipeline);
export default __webpack_public_path__ + "static/media/etl-openai-pipeline.c1b14a6a9181f45cbf35b7ebf67842bf.svg";
export { ForwardRef as ReactComponent };